// Needs to have the same name as the Feature enum in CLB!

export enum FeatureSwitch {
  FEATURE_FOR_UNIT_TESTS = 'FEATURE_FOR_UNIT_TESTS',
  PPA_11933_USE_NEW_SUPPLY_DEMAND = 'PPA_11933_USE_NEW_SUPPLY_DEMAND',
}

export const FeatureSwitchesDefaultValues: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_11933_USE_NEW_SUPPLY_DEMAND]: false,
}

export const ALL_FEATURES_ENABLED: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_11933_USE_NEW_SUPPLY_DEMAND]: true,
}

export type FeatureSwitchMap = Partial<Record<FeatureSwitch, boolean>>
